import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getStringDate } from 'src/app/common/util';
import { EntryNote } from 'src/app/models/entry-note';
import { ResponseObject } from 'src/app/models/response-object.model';
import { EntryNoteService } from 'src/app/services/entry-note.service';

@Component({
  selector: 'app-entry-note',
  templateUrl: './entry-note.component.html',
  styleUrls: ['./entry-note.component.scss']
})
export class EntryNoteComponent implements OnInit {
  createNote: boolean = false;
  filterWord: string = null;
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };
  notes: EntryNote[] = [];
  deletinfNoteId: number = null;
  loadingDelete: boolean = false;
  deleting: { [key: string]: boolean } = {};
  waitingFor = null;
  entryNote = null;
  showDetailsId = null;

  constructor(
    private entryNoteService: EntryNoteService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {
    this.getNotes();
  }

  getNotes() {
    this.entryNoteService.getEntryNotes().subscribe({
      next: (response: ResponseObject) => {
        this.notes = response.data;
        this.setNotes();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error('Error al obtener las notas de entrada', 'Error');
      }
    });
  }

  setNotes() {
    this.pagination.total = this.notes;
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  pageChange(event) {
    this.pagination.pageIndex = event.pageIndex;
    this.pagination.startElement = event.pageIndex * event.pageSize;
    this.pagination.filter = this.pagination.total.slice(this.pagination.startElement, this.pagination.startElement + event.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  searching() {
    this.pagination.total = this.notes.filter((note) => {
      return note.noteNumber.toString().toLowerCase().includes(this.filterWord)
    });
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  closeCreateNote(created) {
    if (created) {
      this.getNotes();
    }
    this.createNote = false;
  }

  convertToString(date: number) {
    if (!date) {
      return '';
    }
    var tempDate = new Date(date);
    return getStringDate(tempDate);
  }

  showDetails(note: EntryNote) {
    this.entryNote = note;
    this.showDetailsId = note.id;
  }

  closeDetails() {
    this.entryNote = null;
    this.showDetailsId = null;
  } 

  downloadNote(note: EntryNote) {
    // this.entryNoteService.getEntryNoteById(note.id).subscribe({
    //   next: (response: ResponseObject) => {
    //     const file = new Blob([response.data.pdf], { type: 'application/pdf' });
    //     const fileURL = URL.createObjectURL(file);
    //     window.open(fileURL);
    //   },
    //   error: (error: HttpErrorResponse) => {
    //     this.toastService.error('Error al descargar la nota de entrada', 'Error');
    //   }
    // });
  }

  resetDeletingDiv() {
    this.waitingFor = null;
  }

  confirmDelete(note: any) {
    if (this.deleting[note.id]) {
      return;
    }
    this.deleting[note.id] = true;
    this.waitingFor = null;
    this.entryNoteService.deleteEntryNote(note.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success('Nota de entrada eliminada con éxito', 'Éxito');
        this.loadingDelete = false;
        this.deletinfNoteId = null;
        this.getNotes();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error('Error al eliminar la nota de entrada', 'Error');
        this.loadingDelete = false;
        this.deletinfNoteId = null;
      }
    });
  }

  deleteNote(x: any) {
    this.waitingFor = x;
  }
  
}
